// extracted by mini-css-extract-plugin
export default {"img":"Logo_img__G6-ha"};